import {
  components,
} from '@/generated/qmulus/openapi.ts';

const maintenanceRecurrencePeriod: Record<NonNullable<components['schemas']['MaintenanceSeriesCreate']['recurrence']['period']>, string> = {
  never: 'Nigdy',
  week: 'Tygodnie',
  month: 'Miesiące',
  year: 'Lata',
};

export default {
  title: 'Nawrót',
  repeat: 'Powtórz',
  every: 'Każdy',
  on: 'NA',
  end: 'Koniec',
  maintenanceRecurrencePeriod,
  selectMonths: 'Wybierz miesiące',
};
